import Page from "../../components/layout/Page";
import { Spin } from 'antd';
import { useEffect } from "react";
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import "./index.scss";
import { postRequest } from "../../services/requestService";
import { useAuth0 } from "@auth0/auth0-react";
import { setUserDetails } from "../../store/reducers/Auth/actions";
import { getTrackingParams, setUserProperties, reportEvent, reportScreen } from "../../services/analyticsService";
import * as Sentry from '@sentry/react';
import { getRedirectUrl } from "../../services/clientService";

export default props => {
    const { user, getAccessTokenSilently, isLoading, loginWithRedirect } = useAuth0();
    const dispatch = useDispatch()

    const fetchUser = async () => {
        reportEvent('auth_callback', 'start')
        const token = await getAccessTokenSilently();
        try {
            const res = await postRequest('auth/callback', {
                trackingParams: getTrackingParams()
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
            if (res.data.userDetails) {
                reportEvent('auth_callback', 'success')
                setUserProperties(res.data.userDetails)
                dispatch(setUserDetails(res.data.userDetails))
                const redirectUrl = getRedirectUrl()
                if (redirectUrl) {
                    window.location.href = redirectUrl;
                }
                else {
                    dispatch(push('/'))
                }

            }
            else throw new Error("Missing user details in auth callback")
        }
        catch (e) {
            reportEvent('auth_callback', 'failure')
            Sentry.captureException(e)
            // TODO: Do something with the user
        }
    }
    useEffect(() => {
        reportScreen('auth_callback')
    }, [])
    useEffect(() => {
        if (!isLoading) {
            if (user) {
                fetchUser(user)
            }
            else {
                loginWithRedirect()
            }

        }
    }, [user, isLoading])

    return (
        <Page className="auth-callback-page">
            <Spin size={50} style={{ fontSize: 30 }} />
        </Page>
    )
}